import {ChartLineOptions} from './chart-line-options';

export class ChartAreaOptions extends ChartLineOptions {

    public static fill = true;
}



// WEBPACK FOOTER //
// ./src/app/components/charts/chart/model/options-type/chart-area-options.ts